<template>
  <b-container fluid class="minting">
    <b-row class="title">
      <b-col>
        <div class="minting-title">
          <img
            src="@/assets/rebrand/home/img-minting-title.png"
            alt="minting title"
            class="img-minting-title"
          />
        </div>
      </b-col>
    </b-row>
    <b-row class="information position-relative">
      <b-col md="6" class="desc">
        <ul>
          <li>
            <img
              src="@/assets/rebrand/home/Minting-bullet.png"
              alt="minting bullet"
              class="img-minting-bullet"
            />
            <p>DEBUTS 05/17/2022 (ALLOWLIST)</p>
          </li>
          <li>
            <img
              src="@/assets/rebrand/home/Minting-bullet.png"
              alt="minting bullet"
              class="img-minting-bullet"
            />
            <p>4,280 GENERATIVE SNEAKER INSPIRED NFT'S</p>
          </li>
        </ul>
      </b-col>
      <b-col md="6">
        <a class="btn-mint-now" href="https://ongaia.com/snkrhud"  target="_blank"></a>
      </b-col>
    </b-row>
    <img src="@/assets/mobile/minting-shape1.png" alt="minting shape" class="minting-shape1 -mb" />
    <img src="@/assets/mobile/minting-shape2.png" alt="minting shape" class="minting-shape2 -mb" />
    <img src="@/assets/mobile/minting-shape3.png" alt="minting shape" class="minting-shape3 -mb" />
    <img src="@/assets/mobile/minting-shape4.png" alt="minting shape" class="minting-shape4 -mb" />
    <img src="@/assets/mobile/minting-grid.png" alt="minting shape" class="minting-grid -mb" />
    <img src="@/assets/rebrand/home/minting-grid.png" alt="minting" class="minting-grid -wb" />
    <img src="@/assets/rebrand/home/minting-bg.png" alt="minting" class="minting-bg -wb" />
  </b-container>
</template>
<script>
export default {
  name: 'Minting',
};
</script>
